var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCityDarkLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 88,
    viewBox: "0 0 377 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333",
    points: "48 2273.876 53.182 2318 425 2274.35 422.454 2252.664 397.807 2249.494 383.593 2251.159 382.712 2243.682 340.823 2248.598 339.768 2239.623 327.799 2241.031 329.554 2255.985 324.319 2256.603 323.084 2246.136 318.82 2242.085 309.096 2243.23 310.587 2255.94 299.363 2257.258 297.518 2241.551 285.549 2242.959 286.957 2254.923 266.009 2257.386 261.565 2251.836 233.882 2255.089 230.191 2249.457 204.754 2252.446 206.072 2263.658 206.682 2268.899 200.701 2269.599 199.473 2259.125 194.238 2259.742 192.649 2246.287 172.454 2248.651 171.927 2244.163 158.458 2245.745 157.23 2235.278 151.242 2235.979 150.542 2230 141.563 2231.054 142.271 2237.033 110.845 2240.722 113.127 2260.164 107.146 2260.872 104.6 2239.179 80.661 2241.995 83.735 2268.168 84.262 2272.656",
    transform: "translate(-48 -2230)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCityDarkLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/city-dark-left.94186977.svg";
export { ForwardRef as ReactComponent };